module.exports = __webpack_public_path__ + "static/img/12yearsbanner.b928efd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/12yearsbanner.jpg
// module id = kexk
// module chunks = 0